import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { pageContext, esEntries, getRulesFromState, get } from 'ctm-util-functions';
import styles from './progress_line.css';

/**
 * ProgressLine Component
 * @param {Object} props React props
 * @returns {_ProgressLine} a ProgressLine component
 */
const _ProgressLine = (props) => {
    // store a local reference to the page schema model
    const   progressLinePageSchemaModel = pageContext.getProps().models.pageSchemaModel;

    /**
     * Get pages to be included in the progress and render each section of the progress bar with appropriate styles
     * @returns {Array} - an array of progress bar 'steps' with configured page details
     */
    const buildLabels = () => {
        // store the path of the current route
        const currentLocation = pageContext.getProps().pageState.path;

        // get the journey schema object
        const pageKey = get(props, 'contentProps.pageKey');
        const journeyPages = progressLinePageSchemaModel.getPageJourneyForProgressBar(pageKey);

        // build an array of progress bar progression links
        const elements = [];
        for (const [index, currentPage] of esEntries(journeyPages)) {
            const active = (currentPage.path === currentLocation);
            const completed = index < journeyPages.findIndex((page) => {
                return page.path === currentLocation;
            });

            const classes = classNames(
                styles.section || null,
                { [styles.completed]: completed },
                { [styles.active]: active },
                { [styles.inactive]: !active && !completed }
            );

            elements.push(
                <div key={`${index}${currentPage}`} className={classes} />
            );
        }

        return elements;
    };

    if (!get(props, 'rules.visibility.result', true)) {
        return null;
    }

    return (
        <div className={styles.root}>
            {buildLabels()}
        </div>
    );
};

_ProgressLine.propTypes = {
    contentProps: PropTypes.object
};

const mapStateToProps = (state, props) => {
    return {
        rules: getRulesFromState(state, props)
    };
};

const ProgressLine = connect(mapStateToProps)(_ProgressLine);

export { _ProgressLine, ProgressLine };
